<template>
  <div>
    <section class="coverage-section">
      <div class="container">
        <h2 class="section-title">Jangkauan Pengiriman</h2>
        <v-row>
          <v-col cols="12">
            <v-card class="coverage-card" elevation="0">
              <v-card-text>
                <div class="coverage-map">
                  <v-img
                    src="@/assets/indonesia-map.png"
                    alt="Peta Jangkauan"
                    contain
                    height="400"
                  ></v-img>
                </div>
                <div class="coverage-info">
                  <div class="coverage-item">
                    <v-icon color="success" class="mr-2"
                      >mdi-check-circle</v-icon
                    >
                    <span>Pengiriman ke 34 Ibukota Provinsi</span>
                  </div>
                  <div class="coverage-item">
                    <v-icon color="success" class="mr-2"
                      >mdi-check-circle</v-icon
                    >
                    <span>Menjangkau lebih dari 7.000 Kecamatan</span>
                  </div>
                  <div class="coverage-item">
                    <v-icon color="success" class="mr-2"
                      >mdi-check-circle</v-icon
                    >
                    <span>Mampu mengantar sampai ke beberapa remote site</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </section>
    <section class="services-section">
      <div class="container">
        <h2 class="section-title">Layanan Kami</h2>
        <p class="service-subtitle">
          Layanan pengiriman yang dapat menyesuaikan kebutuhan dari pelanggan
          dan berkembang seiring dengan perkembangan model bisnis pelanggan
          kebutuhan layanan atas kecepatan waktu, sampai dengan kebutuhan
          layanan dengan biaya pengiriman yang ekonomis.
        </p>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success"
                    >mdi-hand-front-right</v-icon
                  >
                </div>
                <h3 class="service-title">Hand Carry Service</h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success">mdi-airplane</v-icon>
                </div>
                <h3 class="service-title">
                  Pengiriman Door to Door via Udara (Air Freight)
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success">mdi-truck</v-icon>
                </div>
                <h3 class="service-title">
                  Pengiriman Door to Door via Darat (Trucking)
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success">mdi-ferry</v-icon>
                </div>
                <h3 class="service-title">Project Cargo</h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success">mdi-earth</v-icon>
                </div>
                <h3 class="service-title">Remote Site Service</h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success">mdi-folder-move</v-icon>
                </div>
                <h3 class="service-title">Jasa Pindahan (Movers)</h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="service-card" elevation="2">
              <v-card-text class="text-center">
                <div class="icon-circle">
                  <v-icon size="40" color="success"
                    >mdi-package-variant-closed</v-icon
                  >
                </div>
                <h3 class="service-title">Jasa Pengemasan (Repackaging)</h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </section>
    <section class="value-section">
      <div class="container">
        <h2 class="section-title">Nilai Tambah Layanan</h2>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            v-for="(value, index) in valueProps"
            :key="index"
          >
            <div class="value-card">
              <div class="value-icon">
                <v-icon color="warning" size="36">{{ value.icon }}</v-icon>
              </div>
              <div class="value-content">
                <h3>{{ value.title }}</h3>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <div>
      <a :href="whatsappLink" class="whatsapp-button">
        <i class="fab fa-whatsapp"></i> Hubungi Kami di WhatsApp
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayananView",
  data() {
    return {
      whatsappLink:
        "https://api.whatsapp.com/send?phone=6289654367407&text=*Hai%20Admin%20Saya%20mau%20tanya%20tentang%20pengiriman%20barang%20nih%2C%20Saya%20dapat%20wa%20nya%20dari%20Web%20nya%20bdpcargo.co.id%20Terima%20kasih*",
      valueProps: [
        {
          icon: "mdi-clock",
          title: "Waktu Pengantaran Dapat Diandalkan",
        },
        {
          icon: "mdi-shield-check",
          title: "Keamanan Data Terjamin",
        },
        {
          icon: "mdi-account-group",
          title: "Memahami Kebutuhan Pelanggan",
        },
        {
          icon: "mdi-headset",
          title: "Komunikatif Dan Mudah Dihubungi",
        },
        {
          icon: "mdi-earth",
          title: "Jaringan Domestik Yang Solid",
        },
        {
          icon: "mdi-currency-usd",
          title: "Harga Yang Bersaing",
        },
        {
          icon: "mdi-cloud-check",
          title: "Layanan Pelacakan Online dan siap Untuk API",
        },
        {
          icon: "mdi-shield-lock",
          title: "Keamanan Shipment Terjamin",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
// Add these styles before existing styles
.coverage-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
    height: 300px;
    background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
    opacity: 0.1;
    border-radius: 0 0 0 100%;
  }
}

.coverage-card {
  background: transparent;
}

.coverage-map {
  margin-bottom: 40px;
  text-align: center;
}

.coverage-info {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.coverage-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #333;

  &:last-child {
    margin-bottom: 0;
  }

  .v-icon {
    font-size: 24px;
    margin-right: 15px;
  }
}

@media (max-width: 600px) {
  .coverage-section {
    padding: 60px 0;
  }

  .coverage-info {
    padding: 15px;
  }

  .coverage-item {
    font-size: 1rem;
  }
}

.services-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 36px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

.service-subtitle {
  text-align: center;
  color: #666;
  max-width: 800px;
  margin: 0 auto 50px;
  line-height: 1.6;
}

.service-card {
  height: 100%;
  transition: transform 0.3s ease-in-out;
  margin-bottom: 20px;
  border-radius: 15px;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
  }

  .v-card__text {
    padding: 30px;
  }
}

.icon-circle {
  width: 80px;
  height: 80px;
  background-color: #e8f5e9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.service-title {
  margin: 10px 0;
  font-size: 16px;
  color: #2c5282;
  font-weight: 600;
  line-height: 1.4;
}
.value-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 36px;
  color: #333;
  margin-bottom: 50px;
  font-weight: 600;
}

.value-card {
  display: flex;
  align-items: flex-start;
  padding: 30px;
  margin-bottom: 10px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  height: 100%; // Added fixed height
  min-height: 120px; // Added minimum height
  width: 100%; // Added fixed width

  &:hover {
    transform: translateY(-5px);
  }
}

.value-content {
  h3 {
    font-size: 16px; // Reduced font size for better fit
    color: #333;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 3; // Limit to 3 lines
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 100%;
  }
}

@media (max-width: 600px) {
  .value-card {
    flex-direction: column;
    text-align: center;
    min-height: 140px; // Adjusted for mobile
  }

  .value-icon {
    margin: 0 auto 15px;
  }

  .value-content {
    h3 {
      text-align: center;
      -webkit-line-clamp: 4; // Allow 4 lines on mobile
    }
  }
}

@media (max-width: 600px) {
  .value-card {
    flex-direction: column;
    text-align: center;
  }

  .value-icon {
    margin: 0 auto 15px;
  }
}
.whatsapp-button {
  background-color: #25d366;
  color: #fff;
  display: inline-block;
  padding: 10px 20px;
  border-radius: 30px;
  text-decoration: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);

  i {
    margin-right: 10px;
  }
}
</style>
